import _ from "lodash";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { getFormValues, isPristine } from "redux-form";
import { Grid, Header, Button } from "semantic-ui-react";
import { fetchBanner } from "../../actions/index.js";
import "./simple-brand.css";
import Loading from "../../app/loading.js";
import StageBanner from "./banner.js";
import BuylistHeader from "../brand/header.js";
import BannerForm from "./form.js";
import Info from "./info.js";
import { EditButton, CancelButton, DuplicateButton } from "../utils/buttons.js";
import { bannerPresets } from "./presets.js";

const Stage = ({ bannerForm, location, id, template, retailer, pristine }) => {
  const params = useParams();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const banner = useSelector((state) => state.banner);
  const [stage, setStage] = useState("banner");
  const [inEdit, setInEdit] = useState();
  const [bannerData, setBannerData] = useState({});
  const [formOrInfo, setFormOrInfo] = useState(<Info />);

  const handleClick = (comp) => {
    setStage(comp);
  };

  useEffect(() => {
    const path = location.pathname.split("/");
    const status = path[4] ? true : false;
    setInEdit(status);
  }, [location.pathname]);

  useEffect(() => {
    const data = bannerForm || banner;
    setBannerData(data);
    return () => {
      setBannerData({});
    };
  }, [banner, bannerForm]);

  useEffect(() => {
    if (template && !bannerData.bannerType)
      dispatch(fetchBanner(bannerPresets));
  }, [bannerData.bannerType, template, dispatch]);

  useEffect(() => {
    if ((user && params["*"] === "edit") || (user && params["template"])) {
      setFormOrInfo(<BannerForm retailer={retailer} />);
    } else {
      setFormOrInfo(<Info />);
    }
  }, [params, user, retailer]);

  if (_.isEmpty(bannerData)) return <Loading />;

  return (
    <>
      <div className="brand-template">
        <Grid padded>
          <Grid.Row className="bm-title-row">
            <Grid.Column computer={10} tablet={8} mobile={16}>
              <Header as="h3" content={bannerData.bannerTitle} />
            </Grid.Column>
            {user && (
              <Grid.Column computer={6} tablet={8} mobile={16}>
                {bannerData.key && !inEdit && (
                  <DuplicateButton
                    data={bannerData}
                    location={location}
                    inUse={bannerData.currentUser}
                    size="mini"
                  />
                )}
                {!inEdit && (
                  <EditButton
                    id={id}
                    inUse={bannerData.currentUser}
                    size="mini"
                  />
                )}
                <CancelButton
                  id={id}
                  location={location}
                  retailer={retailer}
                  pristine={pristine}
                  size="mini"
                />
              </Grid.Column>
            )}
          </Grid.Row>
          {bannerData.buylistHeader && bannerData.buylistHeader.path && (
            <Grid.Row>
              <Grid.Column width="16">
                <div className="banner-header">
                  <Button size="tiny" onClick={(e) => handleClick("banner")}>
                    Banners
                  </Button>{" "}
                  <Button size="tiny" onClick={(e) => handleClick("header")}>
                    Header
                  </Button>
                </div>
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
        {stage === "banner" ? (
          <StageBanner banner={bannerData} />
        ) : (
          <BuylistHeader banner={bannerData} />
        )}
      </div>
      {formOrInfo}
    </>
  );
};

export default connect((state) => ({
  bannerForm: getFormValues("bannerForm")(state),
  pristine: isPristine("bannerForm")(state),
}))(Stage);
